const conversionFactors = {
  'Grams': 1,
  'Kilograms': 1000,
  'Milligrams': 0.001,
  'Micrograms': 0.000001,
  'Metric Tons': 1000000,
  'Ounces': 28.34952,
  'Pounds': 453.5924,
  'Stone': 6350.293,
  'US Tons': 907184.74,
  'Imperial Tons': 1016046.9,
  'Carats': 0.2,
  'Pennyweights': 1.55517384,
  'Troy Ounces': 31.1034768,
  'Drams': 1.7718451953125,
  'Grains': 0.06479891,
  'Atomic Mass Units': 1.660539040e-24,
  'Daltons': 1.660539040e-24,
  'Slugs': 14593.903,
  'Earth Masses': 5.9722e27,
  'Solar Masses': 1.989e33
};

export const convertWeight = (value, fromUnit, toUnit) => {
  const gramsValue = value * conversionFactors[fromUnit];
  const result = gramsValue / conversionFactors[toUnit];
  
  return Number(result.toPrecision(10));
};
